import {gql} from '@apollo/client';

/**
 * Contact delivery preferences (DBO-1575): Curo's two-option booleans
 * `donotemail` and `t4a_smscorrespondencepreference` (true = "Do Not Allow"),
 * edited from the account overview and written to Curo in the same request.
 * The fragment is what the grid shows and what the mutation returns, so Apollo
 * updates the row from the mutation result.
 */
export const DELIVERY_PREFERENCE_CONTACT_FRAGMENT = gql`
  fragment DeliveryPreferenceContact on ContactType {
    id
    doNotEmail
    doNotSms
  }
`;

export const GET_CONTACT_DELIVERY_PREFERENCES = gql`
  query ContactDeliveryPreferences($accountId: UUID!) {
    contacts(accountId: $accountId) {
      ...DeliveryPreferenceContact
    }
  }
  ${DELIVERY_PREFERENCE_CONTACT_FRAGMENT}
`;

export const UPDATE_DELIVERY_PREFERENCES = gql`
  mutation UpdateDeliveryPreferences(
    $contactId: UUID!
    $accountId: UUID!
    $isEmailAllowed: Boolean!
    $isSmsAllowed: Boolean!
  ) {
    updateDeliveryPreferences(
      contactId: $contactId
      accountId: $accountId
      isEmailAllowed: $isEmailAllowed
      isSmsAllowed: $isSmsAllowed
    ) {
      ok
      errors
      contact {
        ...DeliveryPreferenceContact
      }
    }
  }
  ${DELIVERY_PREFERENCE_CONTACT_FRAGMENT}
`;
